<svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.5" cx="80" cy="80" r="80" fill="#352478" />
    <circle opacity="0.5" cx="80.0002" cy="79.9997" r="56.0544" fill="#352478" />
    <circle cx="79.9998" cy="80.0002" r="37.551" fill="#352478" />
    <path
        d="M94.8751 65.125H68.8433C66.7924 65.125 65.1245 66.7929 65.1245 68.8438V78.1409H68.8433V72.5626L80.7436 81.4878C81.0655 81.7289 81.457 81.8592 81.8592 81.8592C82.2615 81.8592 82.6529 81.7289 82.9749 81.4878L94.8751 72.5626V89.2973H79.9998V93.0162H94.8751C96.926 93.0162 98.5939 91.3483 98.5939 89.2973V68.8438C98.5939 66.7929 96.926 65.125 94.8751 65.125ZM81.8592 77.676L70.0817 68.8438H93.6367L81.8592 77.676Z"
        fill="#EEEBF9" />
    <path
        d="M61.4058 80H74.4216V83.7188H61.4058V80ZM65.1246 85.5782H76.281V89.2971H65.1246V85.5782ZM70.7028 91.1565H78.1405V94.8753H70.7028V91.1565Z"
        fill="#EEEBF9" />
</svg>
